export type PluralForms = readonly [one: string, few: string, many: string];

/** Russian plural form for a count: 1 урок, 2 урока, 5 уроков. */
export function plural(n: number, forms: PluralForms): string {
  const mod100 = Math.abs(n) % 100;
  const mod10 = mod100 % 10;
  if (mod100 > 10 && mod100 < 20) return forms[2];
  if (mod10 === 1) return forms[0];
  if (mod10 >= 2 && mod10 <= 4) return forms[1];
  return forms[2];
}

export function pluralize(n: number, forms: PluralForms): string {
  return `${n} ${plural(n, forms)}`;
}

export const FORMS = {
  lesson: ['урок', 'урока', 'уроков'],
  section: ['раздел', 'раздела', 'разделов'],
  course: ['курс', 'курса', 'курсов'],
  student: ['студент', 'студента', 'студентов'],
  /** After «у»: «у 1 студента», «у 3 студентов». */
  studentOf: ['студента', 'студентов', 'студентов'],
  day: ['день', 'дня', 'дней'],
  code: ['код', 'кода', 'кодов'],
  address: ['адрес', 'адреса', 'адресов'],
  time: ['раз', 'раза', 'раз'],
  author: ['автор', 'автора', 'авторов'],
  academy: ['академия', 'академии', 'академий'],
  banner: ['баннер', 'баннера', 'баннеров'],
  click: ['клик', 'клика', 'кликов'],
} as const satisfies Record<string, PluralForms>;

/** Up to two initials from a full name: «Ирина Павлова» → «ИП». */
export function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0))
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
